import { Injectable, Inject } from '@angular/core';
import {Http, Headers, Response, RequestOptions} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx'
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
import { MyAppSharedSettings} from '../app.setting';
import { ConfigService } from "app/services/config.service";
import { ActivatedRoute, Params } from '@angular/router';

@Injectable()
export class HttpApiService {
    private apiConfigurateurPEUrl = '/DesktopModules/AdminConfigurateurPE/API/Configurateur/GetInit';  // URL to web api
    private apiConfigurateurDataPEUrl = '/DesktopModules/AdminConfigurateurPE/API/Configurateur/GetData';  // URL to web api
    private apiConfigurateurUploadFacadeUrl = '/DesktopModules/AdminConfigurateurPE/API/Configurateur/UploadFacade';  // URL to web api
    private apiUrl = '/DesktopModules/AdminConfigurateurPE/API/Import/HelloWorld';  // URL to web api
    private headers = new Headers({ 
        'Access-Control-Allow-Origin': '*', 
        'Access-Control-Allow-Methods': 'GET, OPTIONS' , 
        'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
        'Access-Control-Allow-Credentials': 'true'
     });
    private options = new RequestOptions({ headers: this.headers, });
    private version = 'lastest';

    constructor(private http: Http, private configService:ConfigService, private activatedRoute: ActivatedRoute) {

        this.activatedRoute.queryParams.subscribe((params:Params) => {
            let lversion = params['version'];
            this.version = (lversion != null && lversion.length > 0 ? lversion : 'lastest');
        });
     }

    getHelloWorld(): Observable<any> {

        let baseUrl = this.configService.getBaseUrlWebApi();
        let url = baseUrl + this.apiUrl;

        return this.http.get(url)
        .map((res:any) => { 
            return res.json();
        });
    }

    getConfigurationInit(): Observable<any> {

        let baseUrl = this.configService.getBaseUrlWebApi();
        let keyAccess = this.configService.getEnseigneKey();
        let urlWithParams = baseUrl + this.apiConfigurateurPEUrl + '?version=' + this.version + '&keyAccess=' + keyAccess;
        return this.http.get(urlWithParams)
        .map((res:any) => { 
            console.log("INIT : ", res.json());
            return res.json();
        });
    }

    getConfigurationData(codeGroupe:string): Observable<any> {

        let baseUrl = this.configService.getBaseUrlWebApi();
        let keyAccess = this.configService.getEnseigneKey();
        let urlWithParams = baseUrl + this.apiConfigurateurDataPEUrl + '?version=' + this.version + '&keyAccess=' + keyAccess + '&codeGroupe=' + codeGroupe;
        return this.http.get(urlWithParams)
        .map((res:any) => { 
            console.log("DATA : ", res.json());
            return res.json();
        });
    }

    //file upload event  
    uploadFacade(file:File, clientId:string): Observable<any> {  

        let baseUrl = this.configService.getBaseUrlWebApi();
        let formData: FormData = new FormData();  
        formData.append('uploadFile', file, file.name);  
        formData.append('clientId', clientId);
        let headers = new Headers()  
        //headers.append('Content-Type', 'json');  
        //headers.append('Accept', 'application/json');  
        let options = new RequestOptions({ headers: headers });  
        let urlWithParams = baseUrl + this.apiConfigurateurUploadFacadeUrl;

        return this.http.post(urlWithParams, formData, options)  
        .map((res:any) => { 
            console.log("DATA uploadFile : ", res.json());
            return res.json();
        });
    }  

}


// WEBPACK FOOTER //
// ./src/app/services/http.api.ts